<p>{{ 'TOKEN_REFRESH.text' | translate }}</p>
<div class="modal-footer">
  <button type="button" class="c-button c-button--secondary" (click)="logout()">
    {{ 'TOKEN_REFRESH.logout' | translate }}
  </button>
  <button type="button" class="c-button c-button--primary" (click)="continueSession()">
    {{ 'TOKEN_REFRESH.continue' | translate }}
  </button>
</div>
